var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.214,
    y: 129.857,
    fill: "#FFFFFF",
    width: 57.39,
    height: 8.199
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "84.604,138.057 94.225,133.958 84.604,129.857  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.091,136.827v-5.739c0-0.68,0.551-1.23,1.231-1.23h7.893v8.201h-7.893 C18.642,138.057,18.091,137.506,18.091,136.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M94.564,133.158l-9.621-4.1c-0.131-0.057-0.272-0.076-0.41-0.064v-0.006H19.322 c-1.158,0-2.099,0.941-2.099,2.1v5.74c0,1.156,0.941,2.099,2.099,2.099h65.211v-0.01c0.023,0.002,0.047,0.01,0.07,0.01 c0.114,0,0.229-0.022,0.34-0.069l9.621-4.101c0.32-0.136,0.528-0.45,0.528-0.799S94.885,133.294,94.564,133.158z M83.734,130.727 v2.361h-55.65v-2.361H83.734z M26.346,137.189h-7.024c-0.2,0-0.362-0.162-0.362-0.361v-5.74c0-0.199,0.162-0.361,0.362-0.361h7.024 V137.189z M28.083,134.826h55.649v2.363H28.083V134.826z M85.473,136.744v-5.571l6.535,2.785L85.473,136.744z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M140.451,14.664c-0.223,0-0.445-0.085-0.616-0.254c-0.339-0.339-0.339-0.889,0-1.228l1.492-1.491 c0.339-0.339,0.888-0.339,1.228,0s0.34,0.89,0,1.229l-1.49,1.49C140.895,14.579,140.672,14.664,140.451,14.664z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M135.784,19.33c-0.222,0-0.443-0.084-0.613-0.254c-0.339-0.338-0.339-0.889,0-1.228l1.489-1.491 c0.34-0.339,0.89-0.339,1.229,0c0.34,0.339,0.34,0.889,0,1.229l-1.49,1.491C136.229,19.246,136.006,19.33,135.784,19.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M141.941,19.33c-0.224,0-0.445-0.084-0.614-0.254l-1.492-1.491c-0.339-0.339-0.339-0.889,0-1.229 c0.34-0.339,0.89-0.339,1.229,0l1.49,1.491c0.34,0.339,0.34,0.889,0,1.228C142.385,19.246,142.163,19.33,141.941,19.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M137.273,14.664c-0.222,0-0.443-0.085-0.613-0.254l-1.489-1.49c-0.339-0.339-0.339-0.889,0-1.229 c0.341-0.339,0.89-0.339,1.228,0l1.49,1.491c0.34,0.339,0.34,0.889,0,1.228C137.718,14.579,137.496,14.664,137.273,14.664z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M140.451,112.939c-0.223,0-0.445-0.084-0.616-0.252c-0.339-0.34-0.339-0.891,0-1.229l1.492-1.491 c0.339-0.34,0.888-0.34,1.228,0s0.34,0.889,0,1.229l-1.49,1.492C140.895,112.855,140.672,112.939,140.451,112.939z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M135.784,117.607c-0.222,0-0.443-0.084-0.613-0.254c-0.339-0.34-0.339-0.891,0-1.229l1.489-1.491 c0.34-0.339,0.89-0.339,1.229,0c0.34,0.34,0.34,0.891,0,1.229l-1.49,1.492C136.229,117.523,136.006,117.607,135.784,117.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M141.941,117.607c-0.224,0-0.445-0.084-0.614-0.254l-1.492-1.492c-0.339-0.338-0.339-0.889,0-1.229 c0.34-0.339,0.89-0.339,1.229,0l1.49,1.491c0.34,0.339,0.34,0.89,0,1.229C142.385,117.523,142.163,117.607,141.941,117.607z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M137.273,112.939c-0.222,0-0.443-0.084-0.613-0.252l-1.489-1.492c-0.339-0.34-0.339-0.889,0-1.229 c0.341-0.34,0.89-0.34,1.228,0l1.49,1.491c0.34,0.339,0.34,0.89,0,1.229C137.718,112.855,137.496,112.939,137.273,112.939z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M5.932,19.92c-0.222,0-0.444-0.085-0.614-0.255c-0.339-0.339-0.339-0.89,0-1.229l1.491-1.49 c0.339-0.339,0.889-0.339,1.229,0c0.339,0.339,0.339,0.89,0,1.229l-1.491,1.49C6.376,19.834,6.154,19.92,5.932,19.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M1.266,24.586c-0.222,0-0.444-0.084-0.614-0.254c-0.339-0.339-0.339-0.889,0-1.229l1.49-1.491 c0.339-0.339,0.889-0.339,1.229,0c0.339,0.339,0.339,0.889,0,1.229l-1.49,1.491C1.71,24.501,1.488,24.586,1.266,24.586z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M7.423,24.586c-0.222,0-0.445-0.084-0.614-0.254l-1.491-1.491c-0.339-0.339-0.339-0.889,0-1.229 c0.339-0.34,0.889-0.339,1.229,0l1.491,1.491c0.339,0.339,0.339,0.889,0,1.229C7.867,24.501,7.645,24.586,7.423,24.586z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M2.756,19.92c-0.222,0-0.444-0.085-0.614-0.255l-1.491-1.49c-0.339-0.338-0.339-0.889,0-1.229 c0.339-0.339,0.889-0.339,1.229,0l1.491,1.49c0.339,0.339,0.339,0.889,0,1.229C3.2,19.834,2.978,19.92,2.756,19.92z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M108.098,5.458l4.598-4.588v108.554c0,5.508-4.459,9.975-9.975,9.975H10.838 c5.506,0,9.975-4.467,9.975-9.975V0.909l0.04-0.04l4.599,4.588l4.588-4.588l4.589,4.588l4.599-4.588l4.588,4.588l4.588-4.588 l4.599,4.588l4.589-4.588l4.588,4.588l4.6-4.587l4.589,4.588l4.588-4.588l4.6,4.588l4.588-4.588l4.588,4.588l4.59-4.588 l4.599,4.588l4.589-4.588L108.098,5.458z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.87,42.444v66.976c0,5.512,4.466,9.977,9.975,9.977c5.509,0,9.976-4.465,9.976-9.977V42.444H0.87z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M10.845,115.921c-3.585,0-6.501-2.916-6.501-6.502V45.918h13.001v63.501 C17.345,113.005,14.429,115.921,10.845,115.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 50.833,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 55.321,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 59.81,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M91.573,66.535h-1.157v-1.737h1.157V66.535z M88.098,66.535h-1.158v-1.737h1.158V66.535z M84.624,66.535 h-1.158v-1.737h1.158V66.535z M81.148,66.535h-1.157v-1.737h1.157V66.535z M77.673,66.535h-1.157v-1.737h1.157V66.535z  M74.2,66.535h-1.159v-1.737H74.2V66.535z M70.724,66.535h-1.158v-1.737h1.158V66.535z M67.25,66.535h-1.158v-1.737h1.158V66.535z  M63.774,66.535h-1.158v-1.737h1.158V66.535z M60.299,66.535h-1.158v-1.737h1.158V66.535z M56.825,66.535h-1.158v-1.737h1.158 V66.535z M53.35,66.535h-1.158v-1.737h1.158V66.535z M49.875,66.535h-1.159v-1.737h1.159V66.535z M46.4,66.535h-1.158v-1.737H46.4 V66.535z M42.925,66.535h-1.158v-1.737h1.158V66.535z M39.45,66.535h-1.159v-1.737h1.159V66.535z M35.975,66.535h-1.158v-1.737 h1.158V66.535z M32.5,66.535h-1.159v-1.737H32.5V66.535z M29.025,66.535h-1.158v-1.737h1.158V66.535z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.867,
    y: 21.528,
    fill: "#231F20",
    width: 78.046,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 69.785,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 74.273,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.158,
    y: 78.761,
    fill: "#231F20",
    width: 21.466,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.449,
    y: 28.389,
    fill: "#231F20",
    width: 21.465,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.449,
    y: 32.877,
    fill: "#231F20",
    width: 21.465,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.449,
    y: 37.367,
    fill: "#231F20",
    width: 21.465,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.449,
    y: 41.855,
    fill: "#231F20",
    width: 21.465,
    height: 1.738
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.449,
    y: 46.343,
    fill: "#231F20",
    width: 21.465,
    height: 1.738
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 50.833,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 55.321,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 59.81,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 69.785,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 74.273,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 78.761,
    fill: "#231F20",
    width: 20.956,
    height: 1.737
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 83.25,
    fill: "#231F20",
    width: 20.956,
    height: 1.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 87.74,
    fill: "#231F20",
    width: 20.956,
    height: 1.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 92.229,
    fill: "#231F20",
    width: 20.956,
    height: 1.735
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 96.716,
    fill: "#231F20",
    width: 20.956,
    height: 1.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.122,
    y: 101.205,
    fill: "#231F20",
    width: 20.956,
    height: 1.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.374,
    y: 28.509,
    fill: "#84DBFF",
    width: 50.999,
    height: 18.639
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40.508,
    y: 12.889,
    fill: "#E6E9EE",
    width: 50.998,
    height: 4.987
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 56.155,
    y: 84.117,
    fill: "#FF7058",
    width: 49.756,
    height: 17.955
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 121.932,
    cy: 73.981,
    r: 27.202
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#84DBFF",
    cx: 121.93,
    cy: 73.981,
    r: 22.024
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#84DBFF",
    d: "M105.451,73.981c0-9.102,7.378-16.48,16.48-16.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105.451,74.849c-0.479,0-0.869-0.389-0.869-0.868c0-9.566,7.781-17.349,17.35-17.349 c0.48,0,0.869,0.389,0.869,0.869s-0.389,0.869-0.869,0.869c-8.607,0-15.611,7.003-15.611,15.611 C106.318,74.46,105.93,74.849,105.451,74.849z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9EE",
    d: "M121.932,149.131L121.932,149.131c-2.182,0-3.949-1.767-3.949-3.947v-30.654 c0-2.18,1.769-3.947,3.949-3.947l0,0c2.18,0,3.947,1.77,3.947,3.947v30.654C125.879,147.365,124.111,149.131,121.932,149.131z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M150,73.981c0-15.478-12.591-28.071-28.068-28.071c-2.914,0-5.725,0.447-8.367,1.274V0.87 c0-0.352-0.211-0.668-0.535-0.803c-0.325-0.135-0.699-0.06-0.948,0.188l-3.983,3.975l-3.975-3.975 c-0.326-0.326-0.902-0.326-1.229,0L98.919,4.23l-3.983-3.975c-0.34-0.338-0.891-0.339-1.229,0L89.73,4.229l-3.974-3.974 c-0.34-0.34-0.89-0.34-1.229,0L80.555,4.23L76.57,0.255c-0.34-0.338-0.889-0.339-1.229,0l-3.974,3.974l-3.975-3.974 c-0.34-0.34-0.889-0.339-1.229,0L62.181,4.23l-3.975-3.975c-0.339-0.34-0.889-0.34-1.229,0L53.003,4.23l-3.984-3.975 c-0.339-0.338-0.889-0.339-1.228,0l-3.974,3.974l-3.974-3.974c-0.339-0.34-0.889-0.339-1.228,0L34.63,4.23l-3.975-3.975 c-0.326-0.326-0.902-0.326-1.229,0L25.452,4.23l-3.984-3.975c-0.34-0.34-0.93-0.3-1.268,0.04 c-0.163,0.163-0.255,0.384-0.255,0.614v40.666H0v67.844c0,5.972,4.85,10.829,10.816,10.845c0.007,0,0.014,0.002,0.021,0.002 h91.882c5.979,0,10.844-4.863,10.844-10.843v-8.646c2.379,0.742,4.896,1.16,7.498,1.238v7.784 c-2.242,0.411-3.947,2.37-3.947,4.729v30.654c0,2.655,2.162,4.816,4.816,4.816c2.656,0,4.816-2.161,4.816-4.816v-30.654 c0-2.357-1.707-4.316-3.947-4.729v-7.771C137.876,101.566,150,89.168,150,73.981z M1.738,109.419V43.312h18.207v66.111 c0,5.019-4.082,9.103-9.1,9.106v-0.004C5.823,118.527,1.738,114.441,1.738,109.419z M111.827,109.423 c0,5.021-4.085,9.106-9.106,9.106h-86c2.984-1.934,4.961-5.293,4.961-9.106V2.923l3.157,3.149 c0.339,0.338,0.889,0.339,1.228-0.001l3.974-3.974l3.975,3.974c0.339,0.34,0.889,0.339,1.228,0.001l3.984-3.976l3.975,3.975 c0.339,0.34,0.889,0.34,1.229,0l3.975-3.975l3.984,3.976c0.339,0.338,0.888,0.339,1.228-0.001l3.975-3.974l3.974,3.974 c0.339,0.34,0.889,0.339,1.228,0.001l3.984-3.976l3.975,3.975c0.326,0.326,0.902,0.326,1.229,0l3.976-3.975l3.983,3.976 c0.34,0.338,0.889,0.339,1.228-0.001l3.976-3.974l3.976,3.974c0.339,0.34,0.889,0.34,1.229,0l3.976-3.975l3.983,3.976 c0.338,0.338,0.889,0.339,1.228-0.001l3.976-3.974l3.973,3.974c0.34,0.34,0.89,0.339,1.229,0.001l3.116-3.11v44.836 c-2.034,0.788-3.943,1.818-5.719,3.034H84.454v1.737h19.366c-1.002,0.849-1.939,1.771-2.813,2.751H84.449v1.737h15.127 c-0.668,0.879-1.286,1.797-1.848,2.752H84.449v1.737h12.342c-1.27,2.553-2.171,5.319-2.611,8.237H84.45v1.737h9.526 c-0.07,0.811-0.115,1.63-0.115,2.459c0,0.099,0.01,0.194,0.013,0.292H84.45v1.737h9.489c0.067,0.932,0.188,1.848,0.343,2.751 H84.45v1.737h10.176c2.157,9.021,8.681,16.363,17.202,19.664L111.827,109.423L111.827,109.423z M125.01,145.186 c0,1.695-1.383,3.078-3.078,3.078c-1.699,0-3.08-1.383-3.08-3.078v-3.061h6.158V145.186L125.01,145.186z M125.01,140.387h-6.158 V118.05h6.158V140.387z M125.01,114.529v1.783h-6.158v-1.783c0-1.697,1.381-3.078,3.08-3.078 C123.627,111.451,125.01,112.832,125.01,114.529z M121.932,100.314c-14.521,0-26.334-11.813-26.334-26.333 s11.812-26.333,26.334-26.333c14.52,0,26.332,11.813,26.332,26.333C148.264,88.5,136.451,100.314,121.932,100.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M121.932,51.087c-12.623,0-22.896,10.27-22.896,22.894c0,12.625,10.271,22.894,22.896,22.894 c12.623,0,22.893-10.27,22.893-22.894C144.824,61.357,134.555,51.087,121.932,51.087z M121.932,95.137 c-11.668,0-21.158-9.49-21.158-21.156c0-11.666,9.49-21.156,21.158-21.156c11.664,0,21.153,9.491,21.153,21.156 C143.085,85.646,133.596,95.137,121.932,95.137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E9EE",
    cx: 130.986,
    cy: 30.629,
    r: 3.587
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD05B",
    cx: 103.493,
    cy: 131.617,
    r: 3.587
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7058",
    cx: 5.662,
    cy: 6.087,
    r: 2.353
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#E6E9EE",
    cx: 8.336,
    cy: 128.944,
    r: 2.674
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon1);
export default __webpack_public_path__ + "static/media/main_icon_1.ff891bed32a7ffbfbaf267b9ce8a1396.svg";
export { ForwardRef as ReactComponent };